<div class="main-container clarichat" [class.safari-browser]="isSafariBrowser">
  <div class="top-bar d-flex justify-content-between align-items-center">
    <div class="top-bar-actions"></div>
  </div>

  <div class="messages-container" #messagesContainer>
    <!-- Right Scroll Rail -->
    <div class="scroll-rail" *ngIf="currentMessages.length > 0">
      <button
        class="rail-tick"
        *ngFor="let msg of userMessages; let i = index"
        [class.active]="i === activeMessageIndex"
        (click)="scrollToMessage(i)"
        [attr.aria-label]="'Jump to message ' + scrollRailRoman(i)">
        <i class="fa fa-brain" aria-hidden="true"></i>
        <span class="rail-roman">{{ scrollRailRoman(i) }}</span>
      </button>
    </div>

    <!-- Pinned Navigation -->
    <div class="pinned-nav-top-right" *ngIf="pinnedMessages.length > 0">
      <div class="pin-stack-anchor">
        <!-- Up Arrow -->
        <button class="arrow prev" type="button" (click)="scrollToPinned(false); $event.stopPropagation()">
          <i class="fas fa-arrow-up"></i>
        </button>

        <!-- Down Arrow -->
        <button class="arrow next" type="button" (click)="scrollToPinned(true); $event.stopPropagation()">
          <i class="fas fa-arrow-down"></i>
        </button>

        <!-- Pin Count Pill -->
        <button type="button" class="pin-stack-pill" aria-label="Pinned messages" (click)="togglePinStack($event)">
          📌 {{ pinnedMessages.length }} pinned
        </button>

        <!-- Clear All Pins -->
        <button type="button" class="pin-clear-btn" aria-label="Clear all pinned messages" (click)="clearAllPins($event)">
          <i class="fas fa-xmark"></i>
        </button>

        <!-- Pin Stack Preview -->
        <div class="pin-stack-preview" *ngIf="showPinStack" (click)="$event.stopPropagation()">
          <div class="pin-stack-title">
            📌 {{ pinnedMessages.length }} pinned
          </div>

          <button
            type="button"
            class="pin-stack-item"
            *ngFor="let pm of pinnedMessages; trackBy: trackMsg"
            (click)="jumpToPinned(pm.id); $event.stopPropagation()">
            <div class="pin-stack-snippet">
              {{ pm.content || '[no text]' }}
            </div>
            <div class="pin-stack-meta">
              {{ messageTimestampModelLabel(pm) }}
              <span *ngIf="pm.timestamp">• {{ pm.timestamp | date:'short' }}</span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <!-- Chat Placeholder -->
    <div class="chat-placeholder-grid-container" *ngIf="currentMessages.length === 0 && !isLoading">
      <div class="placeholder-wrapper" id="placeholderNavArrows">
        <button
          *ngIf="!isTourActive || tourStepId === 'placeholderNavArrows'"
          class="placeholder-nav-arrow placeholder-nav-arrow-left"
          (click)="fastForwardTransition()"
          aria-label="Previous model">
          <i class="fas fa-chevron-left"></i>
        </button>

        <div class="placeholder-content">
          <img
            [src]="currentOption.logoUrl"
            class="grid-item-logo vendor-logo"
            [class.fading]="logoFading"
          />

          <h1 class="placeholder-title" *ngIf="!showMainSubtitle" [class.fading]="modelNameFading">
            <span
              [class]="modelNameClass"
              style="direction:ltr; unicode-bidi:isolate; display:inline-block; white-space:nowrap;">
              <span
                *ngFor="let letter of modelNameLetters; let i = index; trackBy: trackByLetter"
                class="model-name-letter"
                [class.waving]="isLetterWaving(i)"
                [class.dissolving]="modelNameFading"
                [style.color]="getLetterColor(i)"
                [style.--letter-index]="i"
                [style.animation-delay]="isLetterWaving(i) ? '0s' : '0s'">
                {{ letter.char === ' ' ? '\u00A0' : letter.char }}
              </span>
            </span>
          </h1>

          <h1 class="placeholder-subtitle jizz bigal-sub" *ngIf="showMainSubtitle">
            The Leading AI Models, All In One Place.
          </h1>

          <h1 class="placeholder-subtitle bigal-sub" *ngIf="!showMainSubtitle" [class.fading]="logoFading">
            {{ currentPlaceholder }}
          </h1>
        </div>

        <button
          *ngIf="!isTourActive || tourStepId === 'placeholderNavArrows'"
          class="placeholder-nav-arrow placeholder-nav-arrow-right"
          (click)="fastForwardTransition()"
          aria-label="Next model">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Message Display -->
    <ng-container *ngFor="let msg of currentMessages; let i = index; trackBy: trackMsg">
      <div
        class="message"
        *ngIf="!shouldHideMessage(msg, i)"
        [id]="'msg-' + msg.id"
        [ngClass]="{ 'user-message': msg.role === 'user', 'assistant-message': msg.role === 'assistant' }"
        (click)="onMessageShellClick(msg, $event)">

       <div class="message-top-row">
  <button
    *ngIf="!msg.pinned"
    type="button"
    class="pin-corner-btn"
    (click)="onPinClick(msg, $event)"
    [attr.aria-pressed]="msg.pinned"
    [attr.title]="msg.pinned ? 'Unpin message' : 'Pin message'">
    <img src="assets/svg/pin.svg" height="25px" />
  </button>

  <button
    *ngIf="msg.pinned"
    type="button"
    class="pin-corner-btn"
    (click)="onPinClick(msg, $event)"
    [attr.aria-pressed]="msg.pinned"
    [attr.title]="msg.pinned ? 'Unpin message' : 'Pin message'">
    <i class="fa-thumbtack" [ngClass]="{ 'fa-solid pinned': msg.pinned }"></i>
  </button>

  <button
    class="message-toggle-chip"
    type="button"
    [attr.aria-pressed]="isBlockCollapsed(i)"
    [attr.title]="isBlockCollapsed(i) ? 'Expand message' : 'Collapse message'"
    (click)="toggleQaCollapse(msg, i, $event)">
    <span class="message-toggle-chip__content">
      <span class="message-toggle-chip__role">{{ msg.role === 'user' ? 'User' : 'Assistant' }}</span>
      <span class="message-toggle-chip__label">{{ isBlockCollapsed(i) ? 'Show block' : 'Hide block' }}</span>
    </span>
    <span class="message-toggle-chip__indicator" aria-hidden="true">
      <i class="fas" [ngClass]="isBlockCollapsed(i) ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </span>
  </button>
</div>

        <!-- Message Content -->
        <div
          *ngIf="msg.content && !isBlockCollapsed(i)"
          class="markdown prism-content"
          [innerHTML]="convertMarkdown(getMessageDisplayContent(msg))"
          appCodeHighlight></div>

        <div *ngIf="msg.role === 'user' && isBlockCollapsed(i)" class="qa-collapsed-summary">
          - Question Collapse -
        </div>
        <div *ngIf="msg.role === 'assistant' && isBlockCollapsed(i)" class="qa-collapsed-summary">
          Response Collapse
        </div>

        <!-- DALL-E Image Section -->
        <div
          *ngIf="!isBlockCollapsed(i) && (msg.modelId === 'dale' || msg.modelId === 'dale2legacy') && (msg.image || (msg.images && msg.images.length > 0))"
          class="dalle-image">
          <img *ngIf="msg.image" [src]="msg.image" class="dalle-img" alt="Generated image" />
          <div *ngIf="msg.images && msg.images.length > 1" class="dalle-variants">
            <img
              *ngFor="let img of msg.images; let imgIndex = index"
              [src]="img"
              class="dalle-img variant"
              [alt]="'Generated image variant ' + (imgIndex + 1)" />
          </div>
        </div>

        <!-- Generic Image Section -->
        <div
          *ngIf="!isBlockCollapsed(i) && (msg.image || (msg.images && msg.images.length)) && msg.modelId !== 'dale' && msg.modelId !== 'dale2legacy'"
          class="image-result">
          <img *ngIf="msg.image" [src]="msg.image" class="image-result__item" />
          <div class="image-result__variants" *ngIf="msg.images && msg.images.length > 0">
            <img *ngFor="let img of msg.images" [src]="img" class="image-result__item" />
          </div>
        </div>

        <!-- Video Section -->
        <div
          *ngIf="!isBlockCollapsed(i) && (msg.videoId || msg.video || msg.thumbnail)"
          class="video-message">
          <img *ngIf="msg.thumbnail && !msg.video" [src]="msg.thumbnail" class="video-thumb" />

          <div *ngIf="!msg.video" class="video-progress">
            <app-bird-loader label="Thinking"></app-bird-loader>
            <span *ngIf="msg.progress != null">{{ msg.progress }}%</span>
          </div>

          <video *ngIf="msg.video" [src]="msg.video" controls playsinline></video>
        </div>

        <div class="message-footer">
          <div class="message-footer-meta">
            <span class="message-timestamp">
              {{ msg.timestamp | date: 'short' }}
            </span>

            <span class="message-meta-chip" *ngIf="msg.role === 'assistant' && messageTimestampModelLabel(msg)">
              {{ messageTimestampModelLabel(msg) }}
            </span>

            <button type="button" class="message-timestamp-copy" (click)="onActionCopy(msg, i)">
              Copy
            </button>
          </div>

    <div class="message-footer-actions assistant-actions">
      <span class="actions-anchor">
        <button
          *ngIf="msg.role === 'assistant' && !!msg.id && selectedAssistantMessageId === msg.id"
          class="actions-plus-btn"
          type="button"
          (click)="toggleActionsMenu(msg, $event)">
          +
        </button>

              <div class="actions-dropdown anchored" *ngIf="isActionsMenuOpen(msg)" (click)="$event.stopPropagation()">
                <button type="button" class="actions-item actions-item--copy" (click)="onActionCopy(msg, i)">
                  <span class="icon me-2">📋</span> Copy
                </button>

                <button type="button" class="actions-item" (click)="onActionPin(msg)">
                  <span class="me-2">{{ msg.pinned ? '📌' : '🔖' }}</span>
                  {{ msg.pinned ? 'Unpin Message' : 'Pin Message' }}
                </button>

                <button type="button" class="actions-item" (click)="onActionCopyToClariChat(msg)">
                  <i class="fa-solid fa-book"></i>
                  Add In Notes
                </button>

                <button
                  *ngIf="shouldShowCreateGoogleDocButton(msg)"
                  type="button"
                  class="actions-item"
                  [disabled]="!!(msg?.id && docCreatingById[msg.id])"
                  (click)="onCreateDocClick(msg, $event)">
                  <i class="fa-brands fa-google"></i>
                  {{ msg?.id && docCreatingById[msg.id] ? 'Creating…' : '+GoogleDoc' }}
                </button>

                <button type="button" class="actions-item" (click)="exportMessageToPDF(msg)">
                  <i class="fa-solid fa-file-pdf"></i>
                  PDF Export
                </button>

                <button type="button" class="actions-item" (click)="exportMessageToDOCX(msg)">
                  <i class="fa-solid fa-file-word"></i>
                  DOCX Export
                </button>
              </div>

              <span
                class="action-toast anchored"
                *ngIf="msg?.id && actionToastById[msg.id]"
                [ngClass]="actionToastById[msg.id].type">
                {{ actionToastById[msg.id].text }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Loading Indicator -->
    <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>
  </div>

  <!-- Input Container -->
  <div class="bottomcontainer">
    <div class="input-container">
      <div
        class="composer-shell"
        [class.expanded]="composerExpanded"
        [class.mobile-expanded]="hasSentMessage"
        [ngClass]="{ 'with-effort': selectedModel === 'o3' }">

        <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" style="display:none" />
        <div class="textarea-wrapper">
          <div class="composer-attachment-preview" *ngIf="selectedImagePreview && showVisionPaperclipComposer">
            <img [src]="selectedImagePreview" alt="Attached reference image" />
            <button type="button" (click)="removeAttachedImage()" aria-label="Remove attached image">
              <i class="fas fa-times"></i>
            </button>
          </div>
         <textarea
  #chatTextarea
  id="chatInputTextarea"
  class="user-input-textarea"
  [(ngModel)]="userInput"
  rows="1"
  (input)="autoResize(chatTextarea)"
  [placeholder]="isFocused ? '' : getTextareaPlaceholder()"
  (focus)="onTextareaFocus()"
  (blur)="onTextareaBlur()"
  (keydown.enter)="onEnter($event)"
  (keydown.shift.enter)="onShiftEnter($event, chatTextarea)"
  (keydown)="onKeyDown($event)"
  [disabled]="audioActive"
  [class.disabled-typing]="audioActive">
</textarea>

          <div class="left-actions">
            <div class="composer-tools">
              <button
                type="button"
                class="tools-plus-btn"
                aria-label="Open tools menu"
                (click)="toggleComposerToolsMenu($event)">
                <span class="tools-plus-icon" aria-hidden="true">+</span>
              </button>

              <button
                *ngIf="showVisionPaperclipComposer"
                id="attachImageButton"
                type="button"
                class="composer-paperclip-btn"
                (click)="fileInput.click()"
                aria-label="Attach reference image"
              >
                <i class="fas fa-paperclip"></i>
              </button>

              <div
                class="video-generator-menu composer-tools-menu"
                *ngIf="showComposerToolsMenu"
                (click)="$event.stopPropagation()">

                <div class="tools-menu-section">
                  <div class="tools-menu-title">Quick Actions</div>

                  <button type="button" class="tools-menu-button" (click)="repeatPromptFromComposer()">
                    <span class="tools-menu-icon"><i class="fas fa-clock-rotate-left"></i></span>
                    <span class="tools-menu-label">Repeat Prompt</span>
                  </button>

                  <button type="button" class="tools-menu-button" (click)="openComposerAICatalog()">
                    <span class="tools-menu-label"><i class="fa fa-atom pink"></i>&nbsp;AI Selector</span>
                  </button>

                  <!-- <button type="button" class="tools-menu-button tools-menu-button-advisory" (click)="openComposerAdvisory()">
                    <span class="tools-menu-icon"><i class="fa fa-eye"></i></span>
                    <span class="tools-menu-label">Advisors</span>
                  </button> -->

                  <button
                    *ngIf="selectedModelName"
                    type="button"
                    class="tools-menu-button tools-menu-model-button"
                    (click)="openComposerModelInfo()">
                    <span class="tools-menu-icon"><i class="fas fa-info-circle"></i></span>
                    <span class="tools-menu-label">{{ selectedModelName }}</span>
                  </button>
                </div>

                <div class="tools-menu-section">
                  <div class="tools-menu-title">Google Doc</div>
                  <button
                    type="button"
                    class="tools-menu-button"
                    [disabled]="composerDriveDocBusy"
                    (click)="createGoogleDocFromComposerQuestion()">
                    <span class="tools-menu-icon"><i class="fab fa-google-drive"></i></span>
                    <span class="tools-menu-label">New doc from my question</span>
                  </button>
                  <button
                    type="button"
                    class="tools-menu-button"
                    [disabled]="composerDriveDocBusy"
                    (click)="createGoogleDocFromLastAssistantResponse()">
                    <span class="tools-menu-icon"><i class="fab fa-google-drive"></i></span>
                    <span class="tools-menu-label">New doc from last reply</span>
                  </button>
                </div>

                <div class="tools-menu-section">
                  <div class="tools-menu-title">Export</div>

                  <button type="button" class="tools-menu-button" (click)="exportComposerPdf()">
                    <span class="tools-menu-icon">📄</span>
                    <span class="tools-menu-label">Export to PDF</span>
                  </button>

                  <button type="button" class="tools-menu-button" (click)="exportComposerDocx()">
                    <span class="tools-menu-icon">📝</span>
                    <span class="tools-menu-label">Export to DOCX</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Right floating send -->
          <button
            id="sendMessageButton"
            class="btn-send-fixed"
            type="button"
            [class.showing-audio]="!(userInput?.trim()?.length || (showVisionPaperclipComposer && selectedFile))"
            (click)="handleSendOrAudioClick()"
            [disabled]="isLoading">
            <ng-container *ngIf="userInput?.trim()?.length || (showVisionPaperclipComposer && selectedFile)">
              <i class="fas fa-arrow-up"></i>
            </ng-container>
            <!-- <ng-template #audioWaveIcon>
              <img src="assets/icons/audio-wave.svg" class="audio-icon" alt="Audio" />
            </ng-template> -->
          </button>
          <div class="pegasus-video-icon-row" *ngIf="showPegasusVideoComposerIcon">
            <i class="fas fa-video" aria-hidden="true"></i>
          </div>

          <button
            type="button"
            class="textarea-model-status"
            *ngIf="selectedModelName"
            (click)="openComposerAICatalog()"
            aria-label="Open AI selector">
            <span class="textarea-model-name">{{ selectedModelName }}</span>
            <i class="fas fa-chevron-down textarea-model-chevron" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>

    <button
      id="aiCoachFab"
      type="button"
      class="coach-fab"
      [disabled]="coachFabBusy"
      (click)="triggerCoachFab()"
      aria-label="Invoke AI Coach"
    >
      <i class="fa-solid fa-brain" aria-hidden="true"></i>
      <span>{{ coachFabText }}</span>
    </button>

    <!-- Voice Session Success / Failure UI -->
    <div
      *ngIf="voiceSessionState === 'active'"
      style="
        max-width: 980px;
        margin: 12px auto 0;
        padding: 12px 16px;
        border-radius: 14px;
        background: linear-gradient(180deg, rgba(15, 85, 55, 0.95) 0%, rgba(9, 63, 39, 0.98) 100%);
        border: 1px solid rgba(85, 200, 140, 0.35);
        color: #eafff2;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-shadow: 0 10px 24px rgba(5, 20, 14, 0.22);
        font-weight: 700;
        letter-spacing: 0.01em;
      ">
      <i class="fas fa-wave-square" aria-hidden="true"></i>
      <span>{{ voiceSessionMessage }}</span>
    </div>

    <div
      *ngIf="voiceSessionState === 'failed'"
      style="
        max-width: 980px;
        margin: 12px auto 0;
        padding: 14px 16px;
        border-radius: 16px;
        background: linear-gradient(180deg, rgba(40, 26, 8, 0.98) 0%, rgba(24, 15, 4, 1) 100%);
        border: 1px solid rgba(215, 174, 67, 0.28);
        color: #f8e7ae;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        flex-wrap: wrap;
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.24);
      ">
      <div style="display:flex; align-items:center; gap:10px; min-width: 220px;">
        <i class="fas fa-microphone-slash" aria-hidden="true"></i>
        <span style="font-weight:700;">Premium Voice Membership Not Active</span>
      </div>

      <button
        type="button"
        (click)="onPremiumVoiceFeatureClick()"
        style="
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 210px;
          height: 50px;
          padding: 0 22px;
          border: 1px solid rgba(120, 86, 10, 0.55);
          border-radius: 15%;
          background: linear-gradient(180deg, #fff4bf 0%, #f7d86b 22%, #e0b73f 52%, #c9951e 78%, #a97407 100%);
          color: #3d2a00;
          font-size: 14px;
          font-weight: 800;
          letter-spacing: 0.03em;
          text-shadow: 0 1px 0 rgba(255, 255, 255, 0.45);
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.65),
            inset 0 -2px 6px rgba(120, 74, 0, 0.18),
            0 10px 22px rgba(105, 78, 10, 0.22),
            0 2px 5px rgba(0, 0, 0, 0.08);
          cursor: pointer;
          outline: none;
          overflow: hidden;
          white-space: nowrap;
        ">
        Premium Voice Feature
      </button>
    </div>

  </div>
</div>